/*
 * @Author: Liux
 * @Date: 2020-01-02 06:29:09
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 14:28:49
 */
import { Injectable, Injector } from '@angular/core';
import { AdAlertConfig } from './common/ad-alert-config';
import { CONFIG_DATA } from './common/ad-alert-config-inject-key';
import { AdAlertComponent } from './ad-alert.component';
import {
  GlobalPositionStrategy,
  OverlayRef,
  Overlay,
} from '@angular/cdk/overlay';
import { PortalInjector, ComponentPortal } from '@angular/cdk/portal';
@Injectable()
export class AdAlertService {
  overlayRef: OverlayRef;
  overlayConfig: AdAlertConfig;

  constructor(private injector: Injector, private overlay: Overlay) { }

  isNullOrUndefined(val) {
    if (val === null || val === undefined) {
      return true;
    }
    return false;
  }

  open(text: string, config: AdAlertConfig = null): any {
    if (config === null) {
      this.overlayConfig = new AdAlertConfig();
    } else {
      this.overlayConfig = Object.assign(new AdAlertConfig(), config);
    }
    this.openOverlay(text);
    return this.overlayRef;
  }

  close(overlayRef: any) {
    overlayRef.dispose();
  }

  createInjector(dataToPass): PortalInjector {
    const injectorTokens = new WeakMap();
    injectorTokens.set(CONFIG_DATA, dataToPass);
    return new PortalInjector(this.injector, injectorTokens);
  }

  handleMultipleOrOneOverlayRef() {
    if (this.overlayConfig.multiple !== true) {
      if (this.overlayRef && this.overlayRef.hostElement != null) {
        this.overlayRef.dispose();
        this.overlayRef = null;
      }
    }
  }

  openOverlay(content: string) {
    this.handleMultipleOrOneOverlayRef();
    this.overlay.position().global().centerHorizontally();
    this.overlayRef = this.overlay.create({
      positionStrategy: this.getPositionStrategy(),
    });

    this.overlayRef.attach(this.generatePortal(content));
  }

  generatePortal(content: string) {
    const filePreviewPortal = new ComponentPortal(
      AdAlertComponent,
      null,
      this.createInjector({
        config: this.overlayConfig,
        content,
        overlayRef: this.overlayRef,
        close: this.close.bind(this),
      })
    );
    return filePreviewPortal;
  }

  getPositionStrategy() {
    const positionStrategy = this.overlay.position().global();
    let leftOrRight = '';
    let leftOrRightValue: string;
    let topOrBottom = '';
    let topOrBottomValue: string;
    if (
      this.overlayConfig.left !== '' &&
      !this.isNullOrUndefined(this.overlayConfig.left)
    ) {
      leftOrRight = 'left';
      leftOrRightValue = this.overlayConfig.left;
    } else {
      if (
        this.overlayConfig.right !== '' &&
        !this.isNullOrUndefined(this.overlayConfig.right)
      ) {
        leftOrRight = 'right';
        leftOrRightValue = this.overlayConfig.right;
      }
    }

    if (
      this.overlayConfig.top !== '' &&
      !this.isNullOrUndefined(this.overlayConfig.top)
    ) {
      topOrBottom = 'top';
      topOrBottomValue = this.overlayConfig.top;
    } else {
      if (
        this.overlayConfig.bottom !== '' &&
        !this.isNullOrUndefined(this.overlayConfig.bottom)
      ) {
        topOrBottom = 'bottom';
        topOrBottomValue = this.overlayConfig.bottom;
      }
    }
    if (leftOrRight !== '') {
      if (leftOrRight === 'left') {
        positionStrategy.left(leftOrRightValue);
      } else {
        positionStrategy.right(leftOrRightValue);
      }
    }

    if (topOrBottom !== '') {
      if (topOrBottom === 'top') {
        positionStrategy.top(topOrBottomValue);
      } else {
        positionStrategy.bottom(topOrBottomValue);
      }
    }

    if (this.overlayConfig.horizontalCenter) {
      if (leftOrRight === '') {
        positionStrategy.centerHorizontally();
      } else {
        positionStrategy.centerHorizontally(leftOrRight);
      }
    }
    if (this.overlayConfig.verticalCenter) {
      if (topOrBottom === '') {
        positionStrategy.centerVertically();
      } else {
        positionStrategy.centerVertically(topOrBottomValue);
      }
    }

    return positionStrategy;
  }
}
